import axios, { AxiosInstance } from "axios";

export interface EnterprisePortalEventPayload {
  event: string;
  userId: number | null;
  payload: {
    [key: string]: string | number | boolean | object | null;
  };
}

export class AnalyticSender {
  private _axios: AxiosInstance;
  // host defined in vite.config.mts
  constructor() {
    this._axios = axios.create({
      // baseURL: process.env.EVENT_RECEIVER_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  public async post(data: EnterprisePortalEventPayload): Promise<void> {
    try {
      console.info("[ANALYTICS]", data);
      await this._axios.request({
        method: "POST",
        url: "/api/events/enterprise_portal",
        data: { ...data },
      });
    } catch (error) {
      // Fail silently, log error in console
      console.error("Error sending analytics data", error);
    }
  }
}
